<template>
  <div>
    <navbar />
    <nuxt-child :site-name="name" />
    <section v-if="$route.path === '/'" class="section is-small">
      <div class="container">
        <loan-application />
      </div>
    </section>
    <lazy-hydrate ssr-only>
      <footer-comp logo="footer_logo.png" />
    </lazy-hydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'

export default {
  layout: 'whitelabel',
  components: {
    LazyHydrate,
    footerComp: () => import( '~/whitelabels/components/footer' ),
    loanApplication: () => import( '~/components/loanApplication' ),
    navbar: () => import( '~/whitelabels/components/navbar' )
  },
  head () {
    const desc = 'Meiltä saat 500 - 50.000 € lainasi halvemmalla!'
    const theme = '#99cc00'
    return {
      title: `${this.name} | Lainahakemus`,
      meta: [
        { hid: 'description', name: 'description', content: desc },
        { hid: 'og:title', name: 'og:title', property: 'og:title', content: this.name },
        { hid: 'og:site_name', name: 'og:site_name', property: 'og:site_name', content: this.name },
        { hid: 'og:description', name: 'og:description', property: 'og:description', content: desc },
        { hid: 'apple-mobile-web-app-title', name: 'apple-mobile-web-app-title', content: this.name },
        { hid: 'theme-color', name: 'theme-color', content: theme }
      ],
      link: [{ rel: 'icon', type: 'image/x-icon', href: require( '~/assets/whitelabels/lendr/favicon.png' ) }]
    }
  },
  data () {
    return {
      name: 'Lendr',
      domain: 'lendr.fi'
    }
  }
}
</script>

<style lang="scss">
@import "~assets/whitelabels/scss/_variables.scss";

$wl-primary: #99cc00;
$wl-body-background: #fff;

$wl-navbar-height: 3.8rem;
$wl-navbar-logo-height: 2rem;

$wl-app-background: #f2fcf2;
$wl-app-border: 1px solid #9c0;

$wl-slider-handle-border: 2px solid white;

$wl-footer-color: white;
$wl-footer-background: #000d29;

@import "~assets/whitelabels/scss/styles.scss";

.whitelabel.lendr {
  @include whitelabel;
}
</style>
